import React, { useState } from "react";
import styles from "./EventsShowcase.module.css";
import { Image, Button, Modal } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import Navigation from "Components/Nav/Nav";

// import useMediaQuery from "services/useMediaQuery";

const EventShowcaseCard = ({
  title,
  subtitle,
  image,
  highlights,
  testimonies,
  galleryThumb = [],
  fullGallery = [],
  reverse,
  // buttonSrc,
}) => {
  // const matchedDesktop = useMediaQuery("(min-width: 900px)");
  const [showModal, setShowModal] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const openLightbox = (src) => setLightboxIndex(src);
  const closeLightbox = () => setLightboxIndex(null);

  const nextImage = () => {
    setLightboxIndex((prev) => (prev + 1) % fullGallery.length);
  };

  const prevImage = () => {
    setLightboxIndex(
      (prev) => (prev - 1 + fullGallery.length) % fullGallery.length
    );
  };

  const normalize = (path) => {
    if (!path) return "";
    const filename = path.toLowerCase().split("/").pop();
    return filename.replace(/\s/g, "");
  };

  return (
    <>
      <div className={styles.eventBlock}>
        <div
          className={`${styles.eventContent} ${reverse ? styles.reverse : ""}`}
        >
          <div className={styles.textSide}>
            <p className={styles.subtitle}>{subtitle}</p>
            <h1 className={styles.title}>{title}</h1>

            <div
              className={styles.imageSide}
              onClick={() => {
                const matchIndex = fullGallery.findIndex(
                  (imgPath) => normalize(imgPath) === normalize(image)
                );

                if (matchIndex !== -1) {
                  openLightbox(matchIndex);
                } else {
                  console.warn("Hero image not found in fullGallery:", image);
                }
              }}
            >
              <Image src={image} fluid className={styles.heroImage} />
            </div>

            <div className={styles.galleryGrid}>
              {galleryThumb.map((thumb, idx) => (
                <motion.img
                  key={idx}
                  src={thumb}
                  alt={`Gallery Thumbnail ${idx + 1}`}
                  className={styles.galleryThumb}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.3, delay: idx * 0.05 }}
                  whileHover={{
                    scale: 1.05,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const matchIndex = fullGallery.findIndex(
                      (imgPath) => normalize(imgPath) === normalize(thumb)
                    );
                    if (matchIndex !== -1) {
                      openLightbox(matchIndex);
                    } else {
                      console.warn(
                        "Thumbnail image not found in fullGallery:",
                        thumb
                      );
                    }
                  }}
                />
              ))}
            </div>

            <hr style={{ border: "none" }} />
            {fullGallery.length > 0 && (
              <div className={styles.viewGalleryBtn}>
                <Button
                  variant="dark"
                  className={styles.viewGalleryBtn}
                  onClick={() => setShowModal(true)}
                >
                  View Full Gallery
                </Button>
              </div>
            )}

            <div className={styles.textGroup}>
              <h3>Event Highlights</h3>
              <p>{highlights}</p>
              <hr />
              <h3>Event Testimonies</h3>
              <p className={styles.testimonies}>{testimonies}</p>

              <p>{/* Optional gallery link */}</p>
            </div>
          </div>
        </div>

        {/* <div className={styles.downArrow}>
          <span>&#x25BC;</span>
        </div> */}

        {/* Modal with full gallery */}
        <Modal
          style={{ background: "#000000c9" }}
          dialogClassName={styles.customModalSize}
          show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{title}: Full Gallery</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={styles.modalGalleryGrid}>
              {fullGallery.map((img, idx) => (
                <motion.img
                  key={idx}
                  src={img}
                  alt={`Full Gallery ${idx + 1}`}
                  className={styles.galleryThumb}
                  onClick={() => openLightbox(idx)}
                  whileHover={{
                    scale: 1.05,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                    cursor: "pointer",
                  }}
                />
              ))}
            </div>
          </Modal.Body>
        </Modal>

        {/* Lightbox Overlay */}
        <AnimatePresence>
          {lightboxIndex !== null && (
            <motion.div
              className={styles.lightboxOverlay}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={closeLightbox}
            >
              {/* CLose X */}
              <button
                className={styles.lightboxClose}
                onClick={(e) => {
                  e.stopPropagation();
                  closeLightbox();
                }}
              >
                &times;
              </button>

              <motion.img
                src={fullGallery[lightboxIndex]}
                alt="Enlarged"
                className={styles.lightboxImage}
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                transition={{ type: "spring", stiffness: 200 }}
                onClick={(e) => e.stopPropagation()} // prevent overlay close on img click
              />

              <button
                className={styles.lightboxArrowLeft}
                onClick={(e) => {
                  e.stopPropagation();
                  prevImage();
                }}
              >
                &#x276E;
              </button>

              <button
                className={styles.lightboxArrowRight}
                onClick={(e) => {
                  e.stopPropagation();
                  nextImage();
                }}
              >
                &#x276F;
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default EventShowcaseCard;
